<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="model" prop="modelId">
          <el-select
            v-model="form.modelId"
            clearable
            placeholder="请选择model"
            :disabled="title == '修改model实例'"
          >
            <el-option
              v-for="item in models.list"
              :key="item.modelId"
              :label="`${item.title}`"
              :value="item.modelId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="key" prop="key">
          <el-input
            v-model.trim="form.key"
            class="fix-width"
            placeholder="请输入key"
          />
        </el-form-item>
        <el-form-item label="method" prop="method">
          <el-input
            v-model.trim="form.method"
            class="fix-width"
            placeholder="请输入method"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import {
    findModelList,
    updateModelInstance,
    createModelInstance,
  } from '@/api/model'
  import { ref, reactive, getCurrentInstance } from 'vue'

  export default {
    name: 'OaCarEdit',
    emits: ['fetch-data'],
    setup(_, { emit }) {
      const uploadToken = ref()

      const { proxy } = getCurrentInstance()
      const title = ref('')
      const dialogFormVisible = ref(false)
      const formRef = ref(null)
      const initForm = () => {
        return {
          modelInstanceId: '',
          title: '',
          modelId: '',
        }
      }
      const form = reactive(initForm())
      const rules = {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        modelId: [{ required: true, trigger: 'blur', message: '请选择model' }],
      }
      const models = ref()
      const showEdit = async (row) => {
        if (row && row.modelInstanceId) {
          title.value = '修改model实例'
          form.modelInstanceId = row.modelInstanceId
          form.title = row.title
          form.modelId = row.basic.modelId
        } else {
          title.value = '新增model实例'
        }
        models.value = await findModelList({ page: 1, size: 999 })
        dialogFormVisible.value = true
      }
      const formReset = (formRef) => {
        if (!formRef) return
        formRef.resetFields()
        Object.assign(form, initForm())
      }
      const close = (formRef) => {
        formReset(formRef)
        dialogFormVisible.value = false
      }
      const save = (formRef) => {
        if (!formRef) return
        formRef.validate(async (valid) => {
          if (valid) {
            const modelInstanceId = form.modelInstanceId
            const data = Object.assign({}, form)
            proxy.$baseConfirm(
              `你确定要${modelInstanceId ? '修改' : '新增'}model实例吗`,
              null,
              async () => {
                modelInstanceId
                  ? await updateModelInstance(data)
                  : await createModelInstance(data)
                proxy.$baseMessage(
                  `${modelInstanceId ? '修改' : '新增'}model实例成功`,
                  'success',
                  false,
                  'vab-hey-message-success'
                )
                emit('fetch-data')
                close(formRef)
              }
            )
          } else {
            return false
          }
        })
      }
      return {
        title,
        formRef,
        form,
        rules,
        dialogFormVisible,
        models,
        showEdit,
        close,
        save,
      }
    },
  }
</script>

<style lang="scss" scoped>
  @mixin size($scale: 1, $type: small) {
    @if $type == large {
      width: 343px * $scale;
    } @else {
      width: 167px * $scale;
    }
    height: 167px * $scale;
  }
  .avatar-uploader {
    .avatar {
      border-radius: 6px;
      transition: all 0.3s ease-in-out;
      @include size;

      &.large {
        @include size(1, large);
      }
    }
  }
  .icon_avatar {
    width: 50px;
    height: 50px;
  }
  .avatar-uploader-icon {
    border: 1px dashed #c0ccda;
    background-color: #fbfdff;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .tags {
    margin-bottom: 5px;
  }
  .tags + .tags,
  .tags + .button-new-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    // margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .disabled .el-upload--picture-card {
    display: none;
  }
  .fix-width {
    width: 500px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .tips {
    color: #aaaaaa;
    margin-left: 50px;
  }
  .el-icon-circle-plus-outline,
  .el-icon-remove-outline {
    font-size: 32px;
    vertical-align: middle;
    cursor: pointer;
  }

  .el-icon-circle-plus-outline {
    color: #409eff;
  }

  .el-icon-remove-outline {
    color: #f56c6c;
    margin-left: 15px;
  }

  .mr-10 {
    margin-right: 10px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
</style>
